import * as React from "react";
import { Button, Form, Grid, Label, Input, InputOnChangeData } from "semantic-ui-react";
import { format, isValid, parse } from "date-fns";

import { CloneClinicResult } from "../models";

interface Props {
    date: Date | null;
    cloneResult?: CloneClinicResult;
    submitted: boolean;
    onDateChanged: (date: Date) => void;
    onDelete: () => void;
    duplicateClone: boolean;
}

const ClinicRecurrence: React.FunctionComponent<Props> = (props) => {
    const { cloneResult, onDateChanged } = props;

    const handleChange = React.useCallback((_event: React.SyntheticEvent<HTMLInputElement>, data: InputOnChangeData) => {
        const date = parse(data.value, "yyyy-MM-dd", new Date());
        if (isValid(date)) {
            onDateChanged(date);
        }
    }, [onDateChanged]);

    return (
        <Grid.Row>
            <Grid.Column width="4">
                <Form.Field>
                    <Input
                        onChange={handleChange}
                        type="date"
                        value={props.date && isValid(props.date) ? format(props.date, "yyyy-MM-dd") : ""}
                    />
                </Form.Field>
            </Grid.Column>
            <Grid.Column width="4">
                <Button onClick={props.onDelete} content="Delete" />
            </Grid.Column>
            <Grid.Column width="4">
                {
                    cloneResult && (cloneResult.roomClashIds.length > 0 || cloneResult.teamPreventUserClashIds.length > 0) &&
                    <Label color="red" basic content="Conflicts with another appointment" />
                }
                {
                    props.submitted && !props.date &&
                    <Label color="red" basic content="A date must be selected" />
                }
                {
                    props.duplicateClone &&
                    <Label color="red" basic content="You cannot clone a clinic twice on the same day" />
                }
            </Grid.Column>
        </Grid.Row>
    );
};

export { ClinicRecurrence };
